import Route from "./Route";
import { useNavigate } from "react-router-dom";
import useAuth from "../useAuth";
import logo from "../assets/logo.jpg";
import { IoPersonSharp } from "react-icons/io5";
import {
  FaUserPlus,
  FaWifi,
  FaTicketAlt,
} from "react-icons/fa";


export default function NavBar() {
  const navigate = useNavigate();
  const { user, menuOpen } = useAuth();

  return (
    <div
      className={`relative bg-white w-full h-screen flex flex-col pt-4 border-r border-gray-200 transition-all duration-300 ${menuOpen ? "px-1" : "items-center"}`}
    >
      {/* Branding / Logo Section */}
      <div
        className={`flex items-center gap-3 px-3 mb-6 ${menuOpen ? "" : "justify-center"}`}
      >
        <div className="relative flex items-center justify-center">
          <img
            src={logo}
            className="w-10 h-10 object-contain rounded-full shadow-sm"
            alt="logo"
          />
        </div>
        {menuOpen && (
          <div className="flex flex-col overflow-hidden">
            <span className="text-sm font-bold text-gray-800 tracking-wide uppercase truncate">
              Bravishmah
            </span>
            <span className="text-[10px] text-gray-500 font-medium truncate">
              Admin Console
            </span>
          </div>
        )}
      </div>

      {/* Navigation Links */}
      <div className="flex-1 overflow-y-auto space-y-1 custom-scrollbar pb-4">
        {!user?.isReadOnly && (
          <>
            <Route
              name="Register Wifi User"
              onClick={() => navigate("registerUser")}
              icon={<FaUserPlus />}
              urlPath="registerUser"
              isCollapsed={!menuOpen}
            />
            <Route
              name="WiFi User"
              onClick={() => navigate("registered-wifi-users")}
              icon={<FaWifi />}
              urlPath="registered-wifi-users"
              isCollapsed={!menuOpen}
            />
            <Route
              name="Track Ticket"
              onClick={() => navigate("track-ticket")}
              icon={<FaTicketAlt />}
              urlPath="track-ticket"
              isCollapsed={!menuOpen}
            />
          </>
        )}

        <div
          className={`my-2 border-t border-gray-100 mx-4 ${!menuOpen && "hidden"}`}
        ></div>

        <Route
          name="Profile"
          onClick={() => navigate("profile")}
          urlPath="profile"
          icon={<IoPersonSharp />}
          isCollapsed={!menuOpen}
        />
      </div>
    </div>
  );
}
